import { Pipe, PipeTransform } from '@angular/core';
import { getInvoiceStatusIcon, InvoiceModel } from '../components/profile-payments/invoice-model';

@Pipe({
  name: 'invoiceStatusIcon',
  standalone: false
})
export class InvoiceStatusIconPipe implements PipeTransform {
  transform(invoiceModel: InvoiceModel): string {
    return getInvoiceStatusIcon(invoiceModel);
  }
}
